import { render, staticRenderFns } from "./NoEthereum.vue?vue&type=template&id=33408bb3&scoped=true&"
var script = {}
import style0 from "./NoEthereum.vue?vue&type=style&index=0&id=33408bb3&lang=styl&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33408bb3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/tovarishfin/dev/personal/crypto-weddings-dapp-vue/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VProgressCircular})
